import styled from "styled-components";
import colors from "../../../config/colors";

export const AppContainer = styled.div`
  background-color: ${colors.darkBackground};
`;
